import { useEffect } from 'react';
import { get } from 'lodash-es';
import { venomHistory } from 'client/utils/history/venom-history';
import { NATIONAL_LEASE_DEALS_PAGE_URL } from 'site-modules/lease-deals/constants/lease-deals-constants';

export const useRedirectOnStateChange = (urlContext, userSelectedStateName) => {
  const stateName = get(urlContext, 'location.state');

  useEffect(() => {
    if (!!urlContext && stateName && userSelectedStateName && userSelectedStateName !== stateName) {
      venomHistory.push(NATIONAL_LEASE_DEALS_PAGE_URL);
    }
  }, [urlContext, stateName, userSelectedStateName]);
};
